import { FunctionComponent } from 'react';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';
import MaterialSymbol from '../../DataDisplay/MaterialSymbol/MaterialSymbol';
import { withStyles } from '../../../utils/utils';
import styles from './Paginator.module.scss';

const classes = withStyles(styles);

export type PaginatorProps = {
  pageCount: number;
  onPageChange: ReactPaginateProps['onPageChange'];
  pageOffset?: number;
};

type FC = FunctionComponent<PaginatorProps>;

// Moved verbatim from client-dashboard's app-local UI/Paginator (ID-13350) so shared/ClientAccountList
// and the host apps consume one primitive. No wrapper element — renders ReactPaginate directly, exactly
// as the app-local version did, to keep the DOM/layout on existing pages byte-identical.
const Paginator: FC = ({ pageCount, onPageChange, pageOffset }: PaginatorProps) => (
  <ReactPaginate
    pageCount={pageCount}
    onPageChange={onPageChange}
    forcePage={pageOffset}
    previousLabel={
      <MaterialSymbol icon="arrow_circle_left" size="24px" fillAmount={1} className={classes('pageClassName')} />
    }
    nextLabel={
      <MaterialSymbol icon="arrow_circle_right" size="24px" fillAmount={1} className={classes('pageClassName')} />
    }
    containerClassName={classes('containerClassName')}
    breakClassName={classes('breakClassName')}
    breakLinkClassName={classes('breakLinkClassName')}
    pageClassName={classes('pageClassName')}
    pageLinkClassName={classes('pageLinkClassName')}
    activeClassName={classes('activeClassName')}
    activeLinkClassName={classes('activeLinkClassName')}
    previousClassName={classes('previousClassName')}
    nextClassName={classes('nextClassName')}
    previousLinkClassName={classes('previousLinkClassName')}
    nextLinkClassName={classes('nextLinkClassName')}
  />
);

export default Paginator;
